import { render, staticRenderFns } from "./UtilVerifiedBadge.vue?vue&type=template&id=149bd6aa&scoped=true"
import script from "./UtilVerifiedBadge.vue?vue&type=script&lang=js"
export * from "./UtilVerifiedBadge.vue?vue&type=script&lang=js"
import style0 from "./UtilVerifiedBadge.vue?vue&type=style&index=0&id=149bd6aa&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "149bd6aa",
  null
  
)

export default component.exports